import { FunctionComponent, useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import { Variables, VariablesProps } from "./Variables";
import { MenuFlags } from "./NewItemButton";

export type DynamicVariableProps = Omit<
  VariablesProps,
  "onFullscreen" | "wrapVariables"
> &
  Partial<MenuFlags>;

export const DynamicVariables: FunctionComponent<DynamicVariableProps> = ({
  readOnly,
  ...props
}) => {
  const [fullscreen, setFullscreen] = useState<boolean>(false);
  const disableFullscreen = () => setFullscreen(false);

  useEffect(() => {
    return () => {
      setFullscreen(false);
    };
  }, []);

  return (
    <>
      <Variables
        {...props}
        readOnly={readOnly}
        onFullscreen={() => setFullscreen(true)}
      />
      <Dialog
        open={fullscreen}
        fullWidth
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              maxWidth: "unset",
            },
          },
        }}
        onClose={disableFullscreen}
      >
        <DialogContent>
          <Box
            sx={{ display: "flex", alignItems: "flex-start", gap: 2, mt: 3 }}
          >
            <Variables
              {...props}
              allowFullscreen={false}
              wrapVariables
              isFullscreen
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={disableFullscreen}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
